/* eslint-disable no-unreachable */
import Box from '@mui/material/Box'
import useStyles from '../style'
import CustomCheckbox from '../../../../components/CustomCheckbox'
import { highlightText } from '../../../../utils/highlight-text'

const TableRow = ({ data, onChangeSelect, search }) => {
  const classes = useStyles()

  return (
    <Box className={classes.tr}>
      <Box className={`${classes.td} ${classes.td_select}`}>
        <CustomCheckbox value={data.selected} onChange={(e) => onChangeSelect(data.id, e)} />
      </Box>
      <Box className={`${classes.td} ${classes.td_platform}`}>{highlightText(data?.EAN, search, classes)}</Box>
      <Box className={`${classes.td} ${classes.td_name}`}>{highlightText(data?.productLabel, search, classes)}</Box>
      <Box className={`${classes.td} ${classes.td_brand}`}>{highlightText(data?.productBrand, search, classes)}</Box>
    </Box>
  )
}

export default TableRow
